import React from "react";
import { Table, Button, Badge, Spinner } from "react-bootstrap";
import { IconEye, IconPackage, IconCash } from "@tabler/icons-react";
import { format } from "date-fns";

const StockTransfersTable = ({ stockTransfers, onViewDetails, Pagination, isAdminMekanik }) => {
  const getStatusBadgeVariant = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "success";
      case "pending":
        return "warning";
      case "cancelled":
        return "danger";
      default:
        return "secondary";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      return format(new Date(dateString), "dd/MM/yyyy HH:mm");
    } catch {
      return dateString;
    }
  };

  if (stockTransfers.loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p className="mt-2">Loading stock transfers...</p>
      </div>
    );
  }

  if (!stockTransfers.data || stockTransfers.data.length === 0) {
    return (
      <div className="text-center py-5">
        <IconPackage size={48} className="text-muted mb-3" />
        <h5 className="text-muted">No Stock Transfers Found</h5>
        <p className="text-muted">There are no stock transfers to display.</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-body p-0">
        <div className="table-responsive">
          <Table hover className="mb-0">
            <thead className="table-light">
              <tr>
                <th className="border-0">Transfer Number</th>
                <th className="border-0">From Warehouse</th>
                <th className="border-0">To Warehouse</th>
                <th className="border-0">Responsible Staff</th>
                <th className="border-0">Transfer Date</th>
                <th className="border-0">Items Count</th>
                <th className="border-0" style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {stockTransfers.data.map((transfer) => (
                <tr key={transfer.id}>
                  <td>
                    <div>
                      <strong>{transfer.transfer_number}</strong>
                      {transfer.notes && (
                        <div className="text-muted small">{transfer.notes}</div>
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      <div>{transfer.from_warehouse?.name || "-"}</div>
                      <small className="text-muted">
                        {transfer.from_warehouse?.code || ""}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div>
                      <div>{transfer.to_warehouse?.name || "-"}</div>
                      <small className="text-muted">
                        {transfer.to_warehouse?.code || ""}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div>
                      <div>{transfer.responsible_staff?.name || "-"}</div>
                      <small className="text-muted">
                        {transfer.responsible_staff?.email || ""}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div>
                      <div>{formatDate(transfer.transfer_date)}</div>
                      <small className="text-muted">
                        Created: {formatDate(transfer.created_at)}
                      </small>
                    </div>
                  </td>
                  <td>
                    <Badge bg="info" text="white">
                      {transfer.items?.length || 0} items
                    </Badge>
                  </td>
                  <td>
                    <div className="d-flex gap-1">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => onViewDetails(transfer, false)}
                        title="View Details"
                      >
                        <IconEye size={16} />
                      </Button>
                      {isAdminMekanik && (
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => onViewDetails(transfer, true)}
                          title="View Details with Price"
                        >
                          <IconCash size={16} />
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        {Pagination && (
          <div className="card-footer">
            {Pagination}
          </div>
        )}
      </div>
    </div>
  );
};

export default StockTransfersTable;